import { useMemo } from 'react'

export function useGetServiceLocationListPropHeaders(
  fieldName: string | undefined,
  value?: string,
) {
  const cellHeader = useMemo(() => {
    let result
    switch (fieldName) {
      case 'address': {
        result = 'View Addresses'
        break
      }
      case 'initialValue': {
        result = value
        break
      }
      case 'recurringValue': {
        result = value

        break
      }
      case 'totalValue': {
        result = value
        break
      }
      case 'divisionId': {
        result = 'View Divisions'
        break
      }
      case 'locationTypeId': {
        result = 'View Location Types'
        break
      }

      case 'externalLocationCode': {
        result = 'View Location Numbers'
        break
      }
      default: {
        //statements;
        break
      }
    }
    return result
  }, [fieldName, value])
  const popHeader = useMemo(() => {
    let result
    switch (fieldName) {
      case 'address': {
        result = 'Service Location Addresses'
        break
      }
      case 'initialValue': {
        result = `Initial Value ${value}`
        break
      }
      case 'recurringValue': {
        result = `Annual Value ${value}`

        break
      }
      case 'totalValue': {
        result = `Total Value ${value}`
        break
      }
      case 'divisionId': {
        result = 'Divisions'
        break
      }
      case 'locationTypeId': {
        result = 'Location Types'
        break
      }

      case 'externalLocationCode': {
        result = 'Location Numbers'
        break
      }
      default: {
        //statements;
        break
      }
    }
    return result
  }, [fieldName, value])

  return {
    cellHeader,
    popHeader,
  }
}
